import React from "react";
import ContentPage from "../components/content-page";
import SEO from "../components/seo";
var MeetingsPage = function MeetingsPage(_ref) {
    var data = _ref.data;
    return /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement(SEO, {
        title: data.allDatoCmsMeeting.nodes[0].title
    }), /*#__PURE__*/ React.createElement(ContentPage, {
        title: data.allDatoCmsMeeting.nodes[0].title,
        content: data.allDatoCmsMeeting.nodes[0].text
    }));
};
var query = "1415589286";
export default MeetingsPage;
